/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { ClosedEnum } from "../../types/enums.js";

export const KillswitchScheduleEndUntilLifted = {
  UntilLifted: "until_lifted",
} as const;
export type KillswitchScheduleEndUntilLifted = ClosedEnum<
  typeof KillswitchScheduleEndUntilLifted
>;

/** @internal */
export const KillswitchScheduleEndUntilLifted$inboundSchema: z.ZodMiniEnum<
  typeof KillswitchScheduleEndUntilLifted
> = z.enum(KillswitchScheduleEndUntilLifted);
/** @internal */
export const KillswitchScheduleEndUntilLifted$outboundSchema: z.ZodMiniEnum<
  typeof KillswitchScheduleEndUntilLifted
> = KillswitchScheduleEndUntilLifted$inboundSchema;
